/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_CancelInputs */

const bn_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বাতিল করুন`)
};

const de_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornieren`)
};

const el_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ματαίωση`)
};

const en_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const hi_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const hu_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mégsem`)
};

const id_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membatalkan`)
};

const it_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancellare`)
};

const ja_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const ko_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소`)
};

const nl_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

const pl_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulować`)
};

const pt_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const ru_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const sv_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avboka`)
};

const tr_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal etmek`)
};

const uk_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати`)
};

const vi_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy bỏ`)
};

const zh_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const zh_hant_action_cancel = /** @type {(inputs: Action_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Action_CancelInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_cancel = /** @type {((inputs?: Action_CancelInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_CancelInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_cancel(inputs)
	if (locale === "de") return de_action_cancel(inputs)
	if (locale === "el") return el_action_cancel(inputs)
	if (locale === "en") return en_action_cancel(inputs)
	if (locale === "es") return es_action_cancel(inputs)
	if (locale === "fr") return fr_action_cancel(inputs)
	if (locale === "hi") return hi_action_cancel(inputs)
	if (locale === "hu") return hu_action_cancel(inputs)
	if (locale === "id") return id_action_cancel(inputs)
	if (locale === "it") return it_action_cancel(inputs)
	if (locale === "ja") return ja_action_cancel(inputs)
	if (locale === "ko") return ko_action_cancel(inputs)
	if (locale === "nl") return nl_action_cancel(inputs)
	if (locale === "pl") return pl_action_cancel(inputs)
	if (locale === "pt") return pt_action_cancel(inputs)
	if (locale === "ru") return ru_action_cancel(inputs)
	if (locale === "sv") return sv_action_cancel(inputs)
	if (locale === "tr") return tr_action_cancel(inputs)
	if (locale === "uk") return uk_action_cancel(inputs)
	if (locale === "vi") return vi_action_cancel(inputs)
	if (locale === "zh") return zh_action_cancel(inputs)
	return zh_hant_action_cancel(inputs)
});